import { translateFn } from '../../../../../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import {
  ExchangeContentControlContentFilteringRuleSettingsFilterByExpression,
  ExchangeContentControlContentFilteringRuleSettingsFilterByExpressionType,
} from '@nirvana/shared/dtos/types/policies/common';

export const MAX_LENGTH = 256;

// validate entity by type
export async function validateExpressionByType(
  type: ExchangeContentControlContentFilteringRuleSettingsFilterByExpressionType,
  expression: string
): Promise<ValidationResult> {
  // validate expression
  if (type === ExchangeContentControlContentFilteringRuleSettingsFilterByExpressionType.REGULAR_EXPRESSION) {
    try {
      const testExpression = new RegExp(expression);
    } catch (e) {
      return {
        valid: false,
        error: translateFn('Invalid regular expression'),
      };
    }
  }

  return { valid: true };
}

// validate duplicates
export function validateDuplicates(
  exclusionItem: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression,
  exclusionsInGrid: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression[]
): ValidationResult {
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression) =>
      exclusionInGrid.text === exclusionItem.text &&
      exclusionInGrid.type === exclusionItem.type &&
      exclusionInGrid.matchCase === exclusionItem.matchCase &&
      exclusionInGrid.wholeWord === exclusionItem.wholeWord
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
